<template>
    <span class="tag" :class="typesClass" :style="{backgroundColor: bgcolor, color: color}">
        <slot></slot>
    </span>
</template>

<script>
  import {isColor} from '../assets/utils';

  export default {
    name: 'tag',
    props: {
      type: {
        validator(value) {
          return ['default', 'select'].indexOf(value) > -1;
        }
      },
      shape: {
        validator(value) {
          return ['circle', 'square'].indexOf(value) > -1;
        }
      },
      color: {
        validator(value) {
          let colorFlag = true;
          if (!value) {
            colorFlag = true;
          } else {
            colorFlag = isColor(value);
          }
          return colorFlag;
        }
      },
      bgcolor: {
        validator(value) {
          let bgflag = true;
          if (value) {
            bgflag = true;
          } else {
            bgflag = isColor(value);
          }
          return bgflag;
        }
      }
    },
    computed: {
      typesClass() {
        if (this.bgcolor) {
          if (this.shape === 'square') {
            return ' tag-radius';
          }
          return '';
        }
        return (this.type ? `tag-${this.type}` : '') + (this.shape === 'square' ? ' tag-radius' : '');
      }
    }
  };
</script>

<style lang="less">
  @import "../assets/base.less";

  .tag {
    display: inline-block;
    position: relative;
    line-height: 1;
    padding: 8px 20px;
    margin: 0 20px 20px 0;
    border-radius: 8px;
    color: #bfbfbf;
    font-size: 32px;
    white-space: nowrap;
    background-color: #fff;
  }

  .tag-radius {
    border-radius: 8px;
    &:after {
      border-radius: 8px;
    }
  }

  .tag-default {
    color: #bfbfbf;
  }

  .tag-select {
    color: @color-main;
  }
</style>



// WEBPACK FOOTER //
// Tag.vue?72943e34